import { render, staticRenderFns } from "./KanbanConfig.vue?vue&type=template&id=23f3207c"
import script from "./KanbanConfig.vue?vue&type=script&lang=js"
export * from "./KanbanConfig.vue?vue&type=script&lang=js"
import style0 from "./KanbanConfig.vue?vue&type=style&index=0&id=23f3207c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports